import { Link } from "react-router-dom";

import { UserHexagonSvg } from "@components/index";

export const RegistrationButton = () => (
  <div>
    <div className="-mx-4 h-px w-dvw bg-black-8 md:w-auto" />
    <div className="pt-6 text-center text-300 font-bold text-black-70 md:pt-14 md:text-left md:text-white-100">
      Don't have an account?
    </div>
    <Link
      to="/register"
      className="mt-6 flex h-14 items-center justify-between rounded-lg bg-secondary-100 px-6 text-button text-white-100"
    >
      Join FBTC
      <UserHexagonSvg />
    </Link>
  </div>
);
